import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=46dd5d20&scoped=true&"
import script from "./MenuEdit.vue?vue&type=script&lang=js&"
export * from "./MenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=46dd5d20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd5d20",
  null
  
)

export default component.exports